import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as gql from '../gql'

import type { TypeParams } from './types'

/** GraphQL CRUDI API for zone-scoped connector definitions. */
@ngCore.Injectable({ providedIn: 'root' })
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public readonly list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context =>
      context ? gql.queries.connectorDefinitions.execute(context) : rxjs.of([]),
  )

  /** @inheritdoc */
  public readonly get: ec.models.Api<TypeParams>['get'] = (context, id) => {
    TypeAsserter.assertIsNotNullish(context)
    return gql.queries.connectorDefinition.execute({ ...context, id })
  }

  /** @inheritdoc */
  public readonly create: ec.models.Api<TypeParams>['create'] = (
    context,
    definition,
  ) => {
    TypeAsserter.assertIsNotNullish(context)
    return gql.mutations.createConnectorDefinition.execute({
      ...context,
      input: gql.inputs.connectorDefinition.INPUT.getGqlFrom(definition),
    })
  }

  /** @inheritdoc */
  public readonly update: ec.models.Api<TypeParams>['update'] = (
    context,
    { id, updates },
  ) => {
    TypeAsserter.assertIsNotNullish(context)
    return gql.mutations.updateConnectorDefinition.execute({
      ...context,
      id,
      updates: gql.inputs.connectorDefinition.UPDATES.getGqlFrom(updates),
    })
  }

  /** @inheritdoc */
  public readonly delete: ec.models.Api<TypeParams>['delete'] = (
    context,
    id,
  ) => {
    TypeAsserter.assertIsNotNullish(context)
    return gql.mutations.deleteConnectorDefinition.execute({ ...context, id })
  }

  /** @inheritdoc */
  public readonly getAttributes: ec.models.Api<TypeParams>['getAttributes'] =
    () =>
      rxjs.of([
        ec.models.Attribute.fromKey<TypeParams>('id', { name: 'ID' }),
        ec.models.Attribute.fromKey<TypeParams>('name', { name: 'Name' }),
        {
          getValueFrom: definition => definition.imports.length,
          id: 'importCount',
          name: 'Imports',
        },
        {
          getValueFrom: definition =>
            definition.imports
              .map(definitionImport => definitionImport.api.path)
              .join(', '),
          id: 'apiPaths',
          name: 'API paths',
        },
      ])
}
